const utils = require('frontend-controller/lib/utils')

module.exports = {
	methods: {
		editSegment: function(segmentID, mailingListAdditionalFields, additionalDataComponentID){
			var self = this;
			var loadAdditionalDataComponent = utils.promise.resolve();

			if(additionalDataComponentID){
				loadAdditionalDataComponent = self.loadComponentModelFields(additionalDataComponentID).then(function(context){
					return utils.promise.resolve(context.action.response);
				});
			}

			loadAdditionalDataComponent.then(function(additionalDataComponent) {
				return self.performAndStoreAction(
					'showEdit_segment_inEffect',
					self.prepareAction('showEdit_segment', segmentID, {
						mailingListAdditionalFields: mailingListAdditionalFields || [],
						additionalDataComponent: additionalDataComponent
					}),
					true
				);
			});
		},

		createSegment: function(mailingListAdditionalFields, mailingListID, additionalDataComponentID){
			var self = this;
			var loadAdditionalDataComponent = utils.promise.resolve();

			if(additionalDataComponentID){
				loadAdditionalDataComponent = self.loadComponentModelFields(additionalDataComponentID).then(function(context){
					return utils.promise.resolve(context.action.response);
				});
			}

			loadAdditionalDataComponent.then(function(additionalDataComponent) {
				return self.performAndStoreAction(
					'showInsert_segment_inEffect',
					self.prepareAction('showInsert_segment', undefined, {
						mailingListAdditionalFields: mailingListAdditionalFields || [],
						additionalDataComponent: additionalDataComponent
					}, {
						source: {
							load: {
								componentData: {
									model: {
										dirtyFields: {
											data: {
												attributes: {
													mailingListID: mailingListID
												}
											}
										}
									}
								}
							}
						}
					}),
					true
				)
			});
		},
		deleteSegment: function(segmentID){
			var self = this;

			if(segmentID){
				return self.performDecision(
					'confirm',
					{
						component:  self,
						title:      storage.__('hint.delete.really.segment.title'),
						message:    storage.__('hint.delete.really.segment.message')
					}
				).then(function(context) {
					if (context.decision.type === 'yes') {
						return self.performAction(
							self.prepareAction('delete_segment', segmentID)
						).then(function(){
							var editSegmentComponent;
							if((editSegmentComponent = (((self.actions['showEdit_segment_inEffect'] || {}).source || {}).load || {}).component)){
								editSegmentComponent.destroy();
							}
							self.refresh();
							return utils.promise.resolve();
						});
					}
					return utils.promise.reject();
				});
			}
			return utils.promise.reject();
		},

		loadComponentModelFields: function(componentID){
			return this.performAction(
				this.prepareAction(
					'loadComponentModelFields',
					componentID
				)
			);
		}
	}
};
